import { render, staticRenderFns } from "./layer-write-off-bill.vue?vue&type=template&id=1fd97fdb&scoped=true&"
import script from "./layer-write-off-bill.vue?vue&type=script&lang=js&"
export * from "./layer-write-off-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd97fdb",
  null
  
)

export default component.exports